module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-mdx/gatsby-browser.js'),
      options: {"plugins":[],"remarkPlugins":[null],"gatsbyRemarkPlugins":[{"resolve":"gatsby-remark-code-titles","options":{"className":"gatsby-remark-code-title"}},{"resolve":"gatsby-remark-autolink-headers","options":{"className":"gatsby-remark-autolink-headers","isIconAfterHeader":true}}],"defaultLayouts":{"starterKit":"/opt/build/repo/src/pages/ProtectedDocTemplate.js","default":"/opt/build/repo/src/pages/DocTemplate.js"}},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"LRE Water Knowledge Base","short_name":"starter","start_url":"/","background_color":"#663399","theme_color":"#663399","display":"minimal-ui","icon":"src/images/gatsby-icon.png"},
    },{
      plugin: require('../node_modules/gatsby-plugin-material-ui/gatsby-browser.js'),
      options: {"plugins":[],"stylesProvider":{"injectFirst":true}},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
